import React from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import styles from "./CustomTimePicker.module.css";

const CustomTimePicker = ({
  label,
  name,
  value,
  defaultValue,
  onChange,
  onBlur,
  placeholder = "Select time",
  disabled = false,
  required = false,
  error,
  helperText,
  className = "",
  inputClassName = "",
  labelClassName = "",
  format = "hh:mm a",
  minTime,
  maxTime,
  size = "sm",
  ...rest
}) => {
  const sizeMap = {
    sm: "small",
    md: "medium",
    lg: "medium",
  };

  const getSxForSize = () => {
    if (size === "lg") {
      return {
        "& .MuiInputBase-input": {
          padding: "14px 16px",
          fontSize: "1.1rem",
        },
      };
    }
    if (size === "sm") {
      return {
        "& .MuiInputBase-input": {
          padding: "8px 12px",
          fontSize: "0.875rem",
        },
      };
    }
    return {};
  };

  const ampm = format.includes("a") || format.includes("A");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className={`${styles.timePickerWrapper} ${className}`}>
        {label && (
          <label
            htmlFor={name}
            className={`${styles.label} ${labelClassName} ${
              disabled ? styles.labelDisabled : ""
            }`}
          >
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}

        <TimePicker
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          minTime={minTime}
          maxTime={maxTime}
          ampm={ampm}
          format={format}
          slotProps={{
            textField: {
              id: name,
              name: name,
              fullWidth: true,
              size: sizeMap[size],
              error: !!error,
              helperText: error || helperText,
              placeholder: placeholder,
              onBlur: onBlur,
              className: inputClassName,
              sx: {
                ...getSxForSize(),
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                },
                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#ef4444",
                  },
                "& .MuiFormHelperText-root.Mui-error": {
                  color: "#ef4444",
                },
              },
            },
          }}
          {...rest}
        />
      </div>
    </LocalizationProvider>
  );
};

export default CustomTimePicker;